import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/política-de-cookies")({
  head: () => buildRouteHead("/es/política-de-cookies", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/declaracion-de-cookies", replace: true });
  },
});
